import { Selection, NodeSelection } from 'prosemirror-state';
import { Slice } from 'prosemirror-model';
import 'prosemirror-commands';
import 'prosemirror-inputrules';

/**
 * TODO: 节点类型是支持gapcursor的，由于目前部分gapcursor定义存在问题，在不保证修改schema的情况下做一层胶水
 * 后续如果schema统一治理，需要将这段代码考虑优化
 */ var allowGapCursor = function(node) {
    if (!node) {
        return false;
    }
    var allow = node.type.spec.allowGapCursor;
    if (allow) {
        return true;
    }
    var textType = [
        "catalog"
    ];
    return textType.includes(node.type.name);
};

/* eslint-disable */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var gapCursorSituation;
(function(gapCursorSituation) {
    gapCursorSituation["beforeInlineNode"] = "beforeInlineNode";
    gapCursorSituation["afterInlineNode"] = "afterInlineNode";
    gapCursorSituation["beforeNode"] = "beforeNode";
    gapCursorSituation["afterNode"] = "afterNode";
})(gapCursorSituation || (gapCursorSituation = {}));
// ::- Gap cursor selections are represented using this class. Its
// `$anchor` and `$head` properties both point at the cursor position.
var GapCursor = /*#__PURE__*/ function(Selection1) {
    _inherits(GapCursor, Selection1);
    var _super = _createSuper(GapCursor);
    function GapCursor($pos, type) {
        _classCallCheck(this, GapCursor);
        var _this;
        _this = _super.call(this, $pos, $pos);
        _this.gapCursorType = type;
        return _this;
    }
    var _proto = GapCursor.prototype;
    _proto.map = function map(doc, mapping) {
        var $pos = doc.resolve(mapping.map(this.head));
        return GapCursor.valid($pos) ? new GapCursor($pos, this.gapCursorType) : Selection.near($pos);
    };
    _proto.content = function content() {
        return Slice.empty;
    };
    _proto.eq = function eq(other) {
        return _instanceof(other, GapCursor) && other.head == this.head;
    };
    _proto.toJSON = function toJSON() {
        return {
            type: "base_custom_gapcursor",
            pos: this.head
        };
    };
    _proto.getBookmark = function getBookmark() {
        return new GapBookmark(this.anchor);
    };
    GapCursor.fromJSON = function fromJSON(doc, json) {
        if (typeof json.pos !== "number") {
            throw new RangeError("Invalid input for GapCursor.fromJSON");
        }
        return new GapCursor(doc.resolve(json.pos));
    };
    GapCursor.valid = function valid($pos) {
        var parent = $pos.parent;
        if (closedBefore($pos) || closedAfter($pos)) return true;
        // todo: 以下四行代码作用未知，参考自：https://github.com/ProseMirror/prosemirror-gapcursor/blob/227647234f6cd97c7c0b1e0dd3eb75aa21e809f5/src/gapcursor.js
        var override = parent.type.spec.allowGapCursor;
        if (override != null) return override;
        var deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    };
    GapCursor.getType = function getType($pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var beforeCheck = function() {
            if (closedBefore($pos)) {
                var _$pos_nodeBefore;
                if ((_$pos_nodeBefore = $pos.nodeBefore) === null || _$pos_nodeBefore === void 0 ? void 0 : _$pos_nodeBefore.isInline) return gapCursorSituation.afterInlineNode;
                return gapCursorSituation.afterNode;
            }
            return null;
        };
        var aftercheck = function() {
            if (closedAfter($pos)) {
                var _$pos_nodeAfter;
                if ((_$pos_nodeAfter = $pos.nodeAfter) === null || _$pos_nodeAfter === void 0 ? void 0 : _$pos_nodeAfter.isInline) return gapCursorSituation.beforeInlineNode;
                return gapCursorSituation.beforeNode;
            }
            return null;
        };
        var checkHandler = [
            beforeCheck,
            aftercheck
        ];
        if (bias !== 0) {
            checkHandler = bias < 0 ? [
                beforeCheck
            ] : [
                aftercheck
            ];
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = checkHandler[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var handler = _step.value;
                var type = handler();
                if (type) {
                    return type;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    GapCursor.findFrom = function findFrom($pos, dir, mustMove) {
        search: for(;;){
            if (!mustMove && GapCursor.valid($pos)) return $pos;
            var pos = $pos.pos;
            var next = null;
            // Scan up from this position
            for(var d = $pos.depth;; d--){
                var parent = $pos.node(d);
                if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                } else if (d == 0) {
                    return null;
                }
                pos += dir;
                var $cur = $pos.doc.resolve(pos);
                if (GapCursor.valid($cur)) return $cur;
            }
            // And then down into the next node
            for(;;){
                var inside = dir > 0 ? next.firstChild : next.lastChild;
                if (!inside) {
                    if (next.isAtom && !next.isText && !NodeSelection.isSelectable(next)) {
                        $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
                        mustMove = false;
                        continue search;
                    }
                    break;
                }
                next = inside;
                pos += dir;
                var $cur1 = $pos.doc.resolve(pos);
                if (GapCursor.valid($cur1)) return $cur1;
            }
            return null;
        }
    };
    _createClass(GapCursor, [
        {
            key: "targetNode",
            get: function get() {
                var res = GapCursor.findFrom(this.$from, -1);
                if (this.gapCursorType === gapCursorSituation.beforeInlineNode || this.gapCursorType === gapCursorSituation.beforeNode) {
                    return res.nodeAfter;
                } else {
                    return res.nodeBefore;
                }
            }
        }
    ]);
    return GapCursor;
}(_wrapNativeSuper(Selection));
GapCursor.prototype.visible = false;
(function() {
    var id = "base_custom_gapcursor";
    if (window["__".concat(id, "__")]) {
        return;
    }
    window["__".concat(id, "__")] = true;
    Selection.jsonID(id, GapCursor);
})();
var GapBookmark = /*#__PURE__*/ function() {
    function GapBookmark(pos) {
        _classCallCheck(this, GapBookmark);
        this.pos = pos;
    }
    var _proto = GapBookmark.prototype;
    _proto.map = function map(mapping) {
        return new GapBookmark(mapping.map(this.pos));
    };
    _proto.resolve = function resolve(doc) {
        var $pos = doc.resolve(this.pos);
        return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos);
    };
    return GapBookmark;
}();
function closedBefore($pos) {
    var keepDepth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var nodeBefore = $pos.nodeBefore;
    // 处于文本中且不在文本开头
    if ($pos.parent.isTextblock && (!nodeBefore || nodeBefore.isText)) return false;
    if (nodeBefore && !nodeBefore.isText && nodeBefore.isInline && allowGapCursor(nodeBefore)) return true;
    if (nodeBefore && nodeBefore.isBlock && allowGapCursor(nodeBefore) && nodeBefore.type.name !== "blockquote") return true;
    if (keepDepth) {
        return false;
    }
    for(var d = $pos.depth; d > 0; d--){
        var index = $pos.index(d);
        // At the start of this parent, look at next one
        if (index == 0) continue;
        // See if the node before (or its first ancestor) is closed
        for(var before = $pos.node(d).child(index - 1); before; before = before.lastChild){
            if ((before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating) && before.type.spec.allowGapCursor) {
                return true;
            }
            if (before.inlineContent) return false;
        }
    }
    // Hit start of document
    return false;
}
/**
 * 检查传入位置的后方节点是否可以允许Gapcursor
 * @param $pos 传入位置
 * @param keepDepth 是否保持深度，默认false表示当与传入位置相同深度下，如果后方不允许Gapcursor，将继续
 * 向下依次寻找首个子孙节点，如果这些节点的均不允许Gapcursor，将继续向上提个深度并继续寻找首个子孙节点。为true则
 * 不进行寻找首个子孙节点操作
 * --> a
 * ----> b
 */ function closedAfter($pos) {
    var keepDepth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var nodeAfter = $pos.nodeAfter;
    // 处于文本中且不在文本尾部
    if ($pos.parent.isTextblock && (!nodeAfter || nodeAfter.isText)) return false;
    if (nodeAfter && !nodeAfter.isText && nodeAfter.isInline && nodeAfter.type.spec.allowGapCursor) return true;
    if (nodeAfter && nodeAfter.isBlock && nodeAfter.type.spec.allowGapCursor && nodeAfter.type.name !== "blockquote") return true;
    if (keepDepth) {
        return false;
    }
    for(var d = $pos.depth; d > 0; d--){
        var index = $pos.indexAfter(d);
        var parent = $pos.node(d);
        if (index == parent.childCount) continue;
        for(var after = parent.child(index); after; after = after.firstChild){
            if ((after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating) && after.type.spec.allowGapCursor) {
                return true;
            }
            if (after.inlineContent) return false;
        }
    }
    return false;
}

export { GapCursor, closedAfter, closedBefore, gapCursorSituation };
//# sourceMappingURL=index.js.map
